import { Tooltip as ReactTooltip } from "react-tooltip";
import useTranslator from "../../hooks/useTranslator";

const ButtonActionTooltip = ({ title }) => {
  const { _t } = useTranslator();
  return (
    <ReactTooltip
      id="button-action-tooltip"
      place="bottom"
      noArrow
      className="react-tooltip-styling button-action-tooltip"
      render={() => (
        <div className="button-action-tooltip-info">
          <img src="/images/high-risk.svg" alt="" />
          <p>{_t(title ?? "thisActionIsNotAllowed")}</p>
        </div>
      )}
    />
  );
};

export default ButtonActionTooltip;
